import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';

import { styles } from './styles';


const DialogApp = ({
  open = true,
  onClose,
  className,
  classes,
  children,
  small,
}) => {
  const componentClasses = classNames(
    { [className]: !!className },
  );

  const dialogClasses = classNames(
    classes.dialog,
    { [classes.dialogSmall]: !!small },
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={componentClasses}
      classes={{ paper: dialogClasses }}
    >
      {children}
    </Dialog>
  );
};

export default withStyles(styles)(DialogApp);



// WEBPACK FOOTER //
// ./src/components/DialogApp/DialogApp.jsx